/* eslint-disable max-len */
import AccountBalanceIcon from '@mui/icons-material/AccountBalance';
import LocationIcon from '@mui/icons-material/LocationCity';
import AccountCircleIcon from '@mui/icons-material/AccountCircle';
import AccountTreeIcon from '@mui/icons-material/AccountTree';
import AddIcon from '@mui/icons-material/AddBoxOutlined';
import AddBusinessIcon from '@mui/icons-material/AddBusiness';
import AddchartIcon from '@mui/icons-material/Addchart';
import RouteIcon from '@mui/icons-material/AltRouteOutlined';
import AppsIcon from '@mui/icons-material/Apps';
import PickupIcon from '@mui/icons-material/ArrowForward';
import BuildIcon from '@mui/icons-material/Build';
import DutiesCostCalculator from '@mui/icons-material/CalculateOutlined';
import { FaBarcode } from '@react-icons/all-files/fa/FaBarcode';
import CompareArrowsIcon from '@mui/icons-material/CompareArrows';
import DashboardIcon from '@mui/icons-material/DashboardOutlined';
import FitnessCenterIcon from '@mui/icons-material/FitnessCenter';
import ImportIcon from '@mui/icons-material/ImportExport';
import LabelIcon from '@mui/icons-material/Label';
import LanguageIcon from '@mui/icons-material/Language';
import WeightIcon from '@mui/icons-material/LineWeight';
import ListIcon from '@mui/icons-material/ListAltOutlined';
import LocalShippingIcon from '@mui/icons-material/LocalShipping';
import LogingLogsIcon from '@mui/icons-material/LoginOutlined';
import MoneyIcon from '@mui/icons-material/MonetizationOn';
import PricingIcon from '@mui/icons-material/Money';
import PlusOneIcon from '@mui/icons-material/PlusOne';
import GlobeIcon from '@mui/icons-material/Public';
import SecurityIcon from '@mui/icons-material/Security';
// import PdfIcon from '@mui/icons-material/PictureAsPdf';
import SettingsIcon from '@mui/icons-material/Settings';
import ShoppingCartIcon from '@mui/icons-material/ShoppingCart';
import StoreIcon from '@mui/icons-material/Store';
import UsersIcon from '@mui/icons-material/SupervisedUserCircle';
import TrackingIcon from '@mui/icons-material/TrackChanges';
import TrendingUpIcon from '@mui/icons-material/TrendingUp';
import VerifiedUser from '@mui/icons-material/VerifiedUser';
import ParcelsIcon from '@mui/icons-material/Work';
import KeyIcon from '@mui/icons-material/Key';
// import ManageAccountsIcon from '@mui/icons-material/ManageAccounts';
import MultiRouteIcon from '@mui/icons-material/AccountTreeRounded';
import { IoIosQrScanner } from '@react-icons/all-files/io/IoIosQrScanner';
import { IoIosAirplane } from '@react-icons/all-files/io/IoIosAirplane';
import { IoIosBarcode } from '@react-icons/all-files/io/IoIosBarcode';
import { IoIosBriefcase } from '@react-icons/all-files/io/IoIosBriefcase';
import { IoMdAirplane } from '@react-icons/all-files/io/IoMdAirplane';

import QuickbooksIcon from 'components/Icons/Quickbooks';
import TrackingCodeIcon from '@mui/icons-material/Code';
import { MuiPage } from './pages';

const pagesEN: readonly MuiPage[] = [
  {
    label: 'Dashboard',
    icon: DashboardIcon,
    pathname: '/admin/dashboard',
    roles: [
      'admin',
      'customer',
      'wholesaler',
      'retailer',
      'reseller',
      'reseller_customer',
      'wholesaler_customer',
      'dev',
      'accounting',
      'accounting_chief',
      'warehouse',
      'analyst',
      'shipping_marketplace',
    ],
  },
  {
    label: 'Accounts',
    icon: UsersIcon,
    roles: [
      'admin',
      'accounting',
      'accounting_chief',
      'warehouse',
      'reseller',
      'retailer',
      'wholesaler',
    ],
    children: [
      {
        label: 'Users',
        icon: AccountCircleIcon,
        pathname: '/admin/users',
        roles: ['admin', 'accounting', 'accounting_chief'],
      },
      {
        label: 'Accounts',
        icon: AccountTreeIcon,
        pathname: '/admin/accounts',
        roles: ['admin', 'accounting', 'accounting_chief'],
      },
      // {
      //   label: 'Accounts pending',
      //   icon: ManageAccountsIcon,
      //   pathname: '/admin/accounts/pending_review',
      //   roles: ['admin', 'accounting', 'accounting_chief'],
      // },
      {
        label: 'White Label',
        icon: LabelIcon,
        roles: ['admin', 'warehouse', 'reseller', 'retailer', 'wholesaler'],
        pathname: '/admin/white-labels',
      },
      {
        label: 'HS Codes Authorizations',
        icon: () => <AppsIcon />,
        pathname: '/admin/harmonized-codes-restrictions-auth',
        roles: ['admin', 'warehouse'],
      },
      {
        label: 'Good Categories',
        icon: () => <AppsIcon />,
        pathname: '/admin/good-categories',
        roles: ['admin', 'warehouse'],
      },
      {
        label: 'HS Code Categories',
        icon: () => <AppsIcon />,
        pathname: '/admin/hs-code-categories',
        roles: ['admin', 'warehouse', 'reseller', 'retailer', 'wholesaler', 'reseller_customer'],
      },
      {
        label: 'HS Codes Categorization',
        icon: () => <AppsIcon />,
        pathname: '/admin/account-hs-code-categorization',
        roles: ['admin', 'warehouse'],
      },
      {
        label: 'HS Codes Interchange',
        icon: () => <AppsIcon />,
        pathname: '/admin/harmonized-codes-interchange',
        roles: ['admin', 'warehouse'],
      },
    ],
  },
  {
    label: 'Parcels',
    icon: ParcelsIcon,
    roles: [
      'admin',
      'warehouse',
      'analyst',
      'reseller',
      'retailer',
      'wholesaler',
      'reseller_customer',
      'read_only',
    ],
    badge: true,
    badgeCallback: 'loadParcelsPendingReview',
    badgeVar: 'countParcelsPendingReview',
    children: [
      {
        label: 'Add New',
        icon: AddIcon,
        pathname: '/admin/edit-parcel',
        roles: [
          'admin',
          'customer',
          'wholesaler',
          'retailer',
          'reseller',
          'reseller_customer',
          'wholesaler_customer',
          'dev',
          'accounting',
          'accounting_chief',
          'warehouse',
          'analyst',
          'shipping_marketplace',
        ],
      },
      {
        label: 'All Parcels',
        icon: ListIcon,
        pathname: '/admin/parcels',
      },
      {
        label: 'Awaiting Shipment',
        icon: ListIcon,
        pathname: '/admin/awaiting-shipping',
        roles: ['admin', 'warehouse'],
      },
      {
        label: 'Imports',
        icon: ImportIcon,
        pathname: '/admin/parcel-imports',
        roles: [
          'admin',
          'customer',
          'wholesaler',
          'retailer',
          'reseller',
          'reseller_customer',
          'wholesaler_customer',
          'dev',
          'accounting',
          'accounting_chief',
          'warehouse',
          'analyst',
          'shipping_marketplace',
        ],
      },
      {
        label: 'Import 3PL Parcels',
        icon: ImportIcon,
        pathname: '/admin/parcel-imports-dl-packet',
        roles: ['admin', 'import_3pl_parcels'],
      },
      {
        label: 'Scan Zone',
        icon: IoIosQrScanner,
        pathname: '/admin/parcel-scan',
        roles: ['admin', 'wholesaler', 'warehouse'],
      },
      {
        label: 'Scan Zone Trial',
        icon: IoIosQrScanner,
        pathname: '/admin/parcel-scanv2',
        roles: ['admin', 'wholesaler', 'warehouse'],
      },
      {
        label: 'Origin Scan',
        icon: IoIosQrScanner,
        pathname: '/admin/origin-scan',
        roles: ['admin', 'wholesaler', 'warehouse'],
      },
      {
        label: 'Tracking Events',
        icon: TrackingIcon,
        pathname: '/admin/tracking-events',
        roles: ['admin', 'wholesaler', 'warehouse'],
      },
      {
        label: 'Duties & Tax Calculator',
        icon: DutiesCostCalculator,
        pathname: '/admin/duties-cost-calculator',
        roles: ['admin', 'warehouse', 'reseller', 'retailer', 'wholesaler'],
      },
      {
        label: 'Weight Adjustment',
        icon: BuildIcon,
        pathname: '/admin/parcel-tools',
        roles: ['admin', 'wholesaler', 'warehouse'],
      },
      {
        label: 'Parcels Taxed Pending',
        icon: ListIcon,
        pathname: '/admin/parcels/taxed-pending',
        roles: ['admin', 'wholesaler', 'warehouse'],
      },
      {
        label: 'Parcels Taxed Paid',
        icon: ListIcon,
        pathname: '/admin/parcels/taxed-paid',
        roles: ['admin', 'wholesaler', 'warehouse'],
      },
      {
        label: 'Amazon Payee Central Reconciliation',
        icon: ListIcon,
        pathname: '/admin/parcels-invoice-xml',
        roles: ['admin'],
      },
    ],
  },
  {
    label: 'Pickups',
    icon: PickupIcon,
    roles: ['admin', 'warehouse', 'reseller', 'retailer', 'wholesaler'],
    children: [
      {
        label: 'Request Pickup',
        icon: AddIcon,
        pathname: '/admin/new-pickup',
      },
      {
        label: 'Pending',
        icon: ListIcon,
        pathname: '/admin/pickups/created',
      },
      {
        label: 'Completed',
        icon: ListIcon,
        pathname: '/admin/pickups/processed',
      },
      {
        label: 'Scan',
        icon: ListIcon,
        pathname: '/admin/pickups/scan-pickup',
      },
    ],
  },
  {
    label: 'Receptacles',
    icon: (fontSize) => <FaBarcode style={{ fill: '#fff', fontSize: fontSize || 14 }} />,
    roles: ['admin', 'warehouse', 'analyst', 'wholesaler'],
    children: [
      {
        label: 'Dashboard',
        icon: DashboardIcon,
        pathname: '/admin/receptacle-dashboard',
      },
      {
        label: 'List',
        icon: ListIcon,
        pathname: '/admin/receptacle-list',
      },
    ],
  },
  {
    label: 'Receptacle Types',
    icon: (fontSize) => <FaBarcode style={{ fill: '#fff', fontSize: fontSize || 14 }} />,
    roles: ['admin'],
    children: [
      {
        label: 'List',
        icon: ListIcon,
        pathname: '/admin/receptacle-type-list',
      },
    ],
  },
  {
    label: 'Dispatches',
    icon: (fontSize) => <IoIosBarcode style={{ fill: '#fff', fontSize: fontSize || 14 }} />,
    roles: ['admin', 'warehouse', 'analyst', 'wholesaler'],
    children: [
      {
        label: 'Load',
        icon: ListIcon,
        pathname: '/admin/load-dispatch',
      },
      {
        label: 'List',
        icon: ListIcon,
        pathname: '/admin/dispatch-list',
      },
      {
        label: 'Pending',
        icon: ListIcon,
        pathname: '/admin/dispatches-pending',
      },
      {
        label: 'Processed',
        icon: ListIcon,
        pathname: '/admin/dispatch-shipped',
      },
      {
        label: 'Airway Bills',
        icon: ListIcon,
        pathname: '/admin/airway-bills',
      },
    ],
  },
  {
    label: 'Undeliverable',
    icon: LocalShippingIcon,
    roles: ['admin', 'warehouse', 'analyst', 'reseller', 'retailer'],
    // pathname: '/admin/parcels-undeliverable',
    badge: true,
    badgeCallback: 'loadUndeliverable',
    badgeVar: 'countUndeliverable',
    children: [
      // {
      //   label: 'Processed',
      //   icon: ListIcon,
      //   pathname: '/admin/parcels-undeliverable/processed',
      // },
      // {
      //   label: 'Action Required',
      //   icon: ListIcon,
      //   pathname: '/admin/parcels-undeliverable/action-required',
      // },
      {
        label: 'All Parcels',
        icon: ListIcon,
        pathname: '/admin/parcels-undeliverable',
      },
    ],
  },
  // {
  //   label: 'Invoices',
  //   pathname: '/admin/invoices',
  //   icon: PdfIcon,
  // },
  {
    label: 'Reports',
    icon: AccountBalanceIcon,
    roles: ['admin', 'accounting', 'accounting_chief'],
    children: [
      {
        label: 'Accounting Invoicing Report',
        icon: ListIcon,
        pathname: '/admin/reports',
      },
      {
        label: 'AMIF',
        icon: ListIcon,
        pathname: '/admin/amif',
      },
      {
        label: 'Colombia 4-72 Manifest',
        icon: ListIcon,
        pathname: '/admin/reports-colombia-manifest',
      },
      // {
      //   label: 'Import Unitizers Dispatches Report',
      //   icon: ListIcon,
      //   pathname: '/admin/unitizers-dispatches-report',
      // },
      {
        label: 'Import Dispatches Report',
        icon: ListIcon,
        pathname: '/admin/dispatches-report',
      },
      {
        label: 'Claims',
        icon: ListIcon,
        pathname: '/admin/claims',
      },
      {
        label: 'BPX KPI',
        icon: ListIcon,
        pathname: '/admin/bpx-kpi',
      },
      {
        label: 'Customs Alerts',
        icon: ListIcon,
        pathname: '/admin/customs-alerts',
      },
    ],
  },
  {
    label: 'Settings',
    icon: SettingsIcon,
    roles: ['admin'],
    children: [
      {
        label: 'Zones',
        icon: LanguageIcon,
        children: [
          {
            label: 'Countries',
            icon: GlobeIcon,
            pathname: '/admin/rates-countries',
          },
          {
            label: 'States',
            icon: ListIcon,
            pathname: '/admin/rates-states',
          },
          {
            label: 'Postal Codes',
            icon: ListIcon,
            pathname: '/admin/rates-postalcodes',
          },
        ],
      },
      // {
      //   label: 'Surchages',
      //   icon: ListIcon,
      //   children: [
      //     {
      //       label: 'Types',
      //       icon: ListIcon,
      //       pathname: '/admin/surchages-types',
      //     },
      //     {
      //       label: 'Airlines',
      //       icon: ListIcon,
      //       pathname: '/admin/surchages-airlines',
      //     },
      //   ],
      // },
      // {
      //   label: 'Rates',
      //   icon: ListIcon,
      //   pathname: '/admin/rates-rates',
      // },
      // {
      //   label: 'Billing',
      //   icon: ListIcon,
      //   children: [
      //     {
      //       label: 'Billing Tiers',
      //       icon: ListIcon,
      //       pathname: '/admin/rates-billing-tiers',
      //     },
      //     {
      //       label: 'Billing Factors',
      //       icon: ListIcon,
      //       pathname: '/admin/rates-billing-factors',
      //     },
      //   ],
      // },
      // {
      //   label: 'Assign Airwaybills',
      //   icon: (fontSize) => <PdfIcon style={{ fill: '#fff' , fontSize: fontSize || 14 }} />,
      //   pathname: '/admin/assign-airwaybills',
      // },
      {
        label: 'Service Deposits',
        icon: (fontSize) => <PricingIcon style={{ fill: '#fff', fontSize: fontSize || 14 }} />,
        pathname: '/admin/service-deposits',
      },
      {
        label: 'Pricing',
        icon: (fontSize) => <MoneyIcon style={{ fill: '#fff', fontSize: fontSize || 14 }} />,
        children: [
          {
            label: 'List Pricing',
            icon: (fontSize) => <MoneyIcon style={{ fill: '#fff', fontSize: fontSize || 14 }} />,
            pathname: '/admin/list-pricing',
          },
          {
            label: 'Compose Pricing',
            icon: (fontSize) => <MoneyIcon style={{ fill: '#fff', fontSize: fontSize || 14 }} />,
            pathname: '/admin/compose-pricing',
          },
          {
            label: 'Compose Costs',
            icon: (fontSize) => <MoneyIcon style={{ fill: '#fff', fontSize: fontSize || 14 }} />,
            pathname: '/admin/compose-costs',
          },
          {
            label: 'Weights',
            icon: FitnessCenterIcon,
            pathname: '/admin/weights',
          },
          {
            label: 'Money Ranges',
            icon: MoneyIcon,
            pathname: '/admin/money-ranges',
          },
          {
            label: 'Tariffs',
            icon: AddchartIcon,
            pathname: '/admin/tariffs',
          },
          {
            label: 'Markup',
            icon: TrendingUpIcon,
            pathname: '/admin/markup',
          },
          {
            label: 'Service Area Tariffs',
            icon: CompareArrowsIcon,
            pathname: '/admin/services-areas-tariffs',
          },
          {
            label: 'Costs',
            icon: WeightIcon,
            pathname: '/admin/services-areas-weights-costs',
          },
          {
            label: 'Insurance Costs',
            icon: VerifiedUser,
            pathname: '/admin/services-areas-insurance-costs',
          },
          {
            label: 'Surcharges',
            icon: PlusOneIcon,
            pathname: '/admin/services-areas-surcharges-costs',
          },
        ],
      },
      {
        label: 'Services',
        icon: ListIcon,
        children: [
          {
            label: 'Service Pickups',
            icon: (fontSize) => <AppsIcon style={{ fill: '#fff', fontSize: fontSize || 14 }} />,
            pathname: '/admin/service-service-pickup',
          },
          {
            label: 'Internal Services',
            icon: (fontSize) => <AppsIcon style={{ fill: '#fff', fontSize: fontSize || 14 }} />,
            pathname: '/admin/internal-services',
          },
          {
            label: 'Internal Services Routing',
            icon: (fontSize) => <AppsIcon style={{ fill: '#fff', fontSize: fontSize || 14 }} />,
            pathname: '/admin/internal-services-services',
          },
          {
            label: 'Services',
            icon: (fontSize) => <AppsIcon style={{ fill: '#fff', fontSize: fontSize || 14 }} />,
            pathname: '/admin/services',
          },
          {
            label: 'Service Countries',
            icon: (fontSize) => <GlobeIcon style={{ fill: '#fff', fontSize: fontSize || 14 }} />,
            pathname: '/admin/service-countries',
          },
          {
            label: 'Service Options',
            icon: (fontSize) => <AppsIcon style={{ fill: '#fff', fontSize: fontSize || 14 }} />,
            pathname: '/admin/service-options',
          },
          {
            label: 'Service Routes',
            icon: (fontSize) => <RouteIcon style={{ fill: '#fff', fontSize: fontSize || 14 }} />,
            pathname: '/admin/service-routes',
          },
          {
            label: 'Service Route Legs',
            icon: (fontSize) => (
              <MultiRouteIcon style={{ fill: '#fff', fontSize: fontSize || 14 }} />
            ),
            pathname: '/admin/service-route-legs',
          },
          {
            label: 'Harmonized Codes Restrictions',
            icon: () => <AppsIcon />,
            pathname: '/admin/harmonized-codes-restrictions',
          },
        ],
      },
      {
        label: 'Harmonized Codes',
        icon: () => <AppsIcon />,
        pathname: '/admin/harmonized-codes',
      },
      {
        label: 'External Services ',
        icon: ListIcon,
        children: [
          {
            label: 'Service Providers ',
            icon: ListIcon,
            pathname: '/admin/rates-service-providers',
          },
          {
            label: 'Services ',
            icon: ListIcon,
            pathname: '/admin/rates-services',
          },
          {
            label: 'Services Areas Tariffs ',
            icon: ListIcon,
            pathname: '/admin/rates-services-areas-tariffs',
          },
          {
            label: 'Services Areas ',
            icon: ListIcon,
            pathname: '/admin/rates-services-areas',
          },
          {
            label: 'Services Rules ',
            icon: ListIcon,
            pathname: '/admin/rates-services-rules',
          },
          {
            label: 'Services Rules types',
            icon: ListIcon,
            pathname: '/admin/rates-services-rules-types',
          },
          {
            label: 'Services Providers Destinations ',
            icon: ListIcon,
            pathname: '/admin/rates-services-providers-destinations',
          },
          {
            label: 'Services Providers Countries ',
            icon: ListIcon,
            pathname: '/admin/rates-services-providers-countries',
          },
        ],
      },
      {
        label: 'Airports',
        icon: (fontSize) => <IoIosAirplane style={{ fill: '#fff', fontSize: fontSize || 14 }} />,
        pathname: '/admin/airports',
      },
      {
        label: 'Airport Routes',
        icon: (fontSize) => <IoIosAirplane style={{ fill: '#fff', fontSize: fontSize || 14 }} />,
        pathname: '/admin/airport-routes',
      },
      {
        label: 'Airports Offices',
        icon: (fontSize) => <IoIosBriefcase style={{ fill: '#fff', fontSize: fontSize || 14 }} />,
        pathname: '/admin/airports-offices',
      },
      {
        label: 'Airlines',
        icon: (fontSize) => <IoMdAirplane style={{ fill: '#fff', fontSize: fontSize || 14 }} />,
        pathname: '/admin/airlines',
      },
      {
        label: 'Tracking',
        icon: TrackingIcon,
        children: [
          {
            label: 'Tracking Codes',
            icon: TrackingCodeIcon,
            pathname: '/admin/tracking-codes',
          },
          {
            label: 'Tracking Codes Customers',
            icon: TrackingCodeIcon,
            pathname: '/admin/tracking-codes-customers',
          },
          {
            label: 'Tracking Codes Vendors',
            icon: TrackingCodeIcon,
            pathname: '/admin/tracking-codes-vendors',
          },
          {
            label: 'Cleaned Locations',
            icon: TrackingCodeIcon,
            pathname: '/admin/cleaned-locations',
          },
        ],
      },
      {
        label: 'Account Restrictions',
        icon: AccountTreeIcon,
        pathname: '/admin/account-service-restrictions',
      },
      {
        label: 'Account Parcel Limit Price',
        icon: AccountTreeIcon,
        pathname: '/admin/account-service-price-limits',
      },
      {
        label: 'Addresses',
        icon: LocationIcon,
        children: [
          {
            label: 'Addresses',
            icon: LocationIcon,
            pathname: '/admin/addresses',
          },
          {
            label: 'Address Details',
            icon: LocationIcon,
            pathname: '/admin/address-details',
          },
        ],
      },
      {
        label: 'Dropoff Stations',
        icon: AccountTreeIcon,
        pathname: '/admin/dropoff-stations',
      },
      {
        label: 'Facilities',
        icon: AccountTreeIcon,
        children: [
          {
            label: 'Facilities List',
            icon: TrackingCodeIcon,
            pathname: '/admin/facilities',
          },
          {
            label: 'Facilities Rules',
            icon: TrackingCodeIcon,
            pathname: '/admin/facilities-inbound-rules',
          },
        ],
      },
      {
        label: 'Quickbooks',
        icon: (fontSize) => <QuickbooksIcon style={{ fill: '#fff', fontSize: fontSize || 14 }} />,
        pathname: '/admin/quickbooks',
      },
      // {
      //   label: 'Inbound Countries',
      //   icon: (fontSize) => <IoIosGlobe style={{ fill: '#fff' , fontSize: fontSize || 14 }} />,
      //   pathname: '/admin/inbound-countries'
      // },
    ],
  },
  {
    label: 'Amazon Store',
    icon: StoreIcon,
    roles: ['admin', 'reseller', 'retailer', 'wholesaler'],
    children: [
      {
        label: 'Authorization',
        icon: KeyIcon,
        pathname: '/admin/stores/amazon/authorization',
      },
      {
        label: 'Orders',
        icon: ShoppingCartIcon,
        pathname: '/admin/stores/amazon/orders',
      },
    ],
  },
  {
    label: 'Stores',
    icon: StoreIcon,
    roles: ['admin', 'reseller', 'retailer', 'wholesaler', 'reseller_customer'],
    children: [
      {
        label: 'List',
        icon: ListIcon,
        pathname: '/admin/stores',
      },
      {
        label: 'Add new store',
        icon: AddBusinessIcon,
        pathname: '/admin/stores/new',
      },
      {
        label: 'Orders',
        icon: ShoppingCartIcon,
        pathname: '/admin/store-orders',
      },
    ],
  },
  {
    label: 'Security',
    icon: SecurityIcon,
    roles: ['admin'],
    children: [
      {
        label: 'Login Logs',
        icon: LogingLogsIcon,
        pathname: '/admin/login-logs',
      },
    ],
  },
];

export default pagesEN;
